// extracted by mini-css-extract-plugin
module.exports = {"Link":"PhoneLink_Link__1TsXV"};